import UniversalCookie from 'universal-cookie'
import axios from 'axios'

const API_MAIN = process.env.REACT_APP_API_MAIN
const API_URL = process.env.REACT_APP_API_URL


export function parseStorage(){
  try{
    const cookie = new UniversalCookie()
    const auth = cookie.get('auth')

    return auth        
  }catch(err){
    //   window.location.href = '/login'
  }    
}


export function login(){
  const cookie = new UniversalCookie()
  axios.post(API_MAIN + `/login`, {
      email: 'desk@optify.co.id',
      password: 'qwerty123'
    } ,{
      headers: {
          'Accept' : 'application/json',
      },        
  }).then((res) => {
    const auth = res.data.results
    cookie.set('auth', JSON.stringify(auth), {path : '/'})
  }).catch((err) => {
    // console.log('login error',err)
  })
}

export function logout(){
  const cookie = new UniversalCookie()
  cookie.remove('auth', {path: '/'});
  // window.location('/login')

  window.location.href = '/login';
}

export function getCategories(categories_id){
  const auth = new parseStorage()
  return dispatch => {
    dispatch({
      type: 'GET_CATEGORIES',
      payload: 
        axios.get(API_URL + `/profile/categories`, {
          headers: {
              'Authorization' : 'Bearer ' + auth.token,
              'Accept' : 'application/json',                
          }})                
    }).then((res) => {
      if(categories_id){
        let {categories} = res.value.data.results;

        for(let i = 0; i < categories.length; i++){
          for(let j = 0; j < categories_id.length; j++){
            if(categories[i].id === categories_id[j]){
              categories[i].checked = true
            }
          }
          if(!categories[i].checked){
            categories[i].checked = false
          }
        }

        dispatch({
          type: 'GET_CATEGORIES_CHECKED',
          categories
        })
      }
    })
  }
}

export function getLocations(location_id){
  const auth = new parseStorage()
  return dispatch => {
    dispatch({
      type: 'GET_LOCATIONS',
      payload: 
        axios.get(API_URL + `/profile/provinces`, {
          headers: {
              'Authorization' : 'Bearer ' + auth.token,
              'Accept' : 'application/json',                
          }})                
    }).then((res) => {
      if(location_id){
        let {data} = res.value.data.results;
        data.map(data => {
          if(data.id === location_id){
            data.checked = true
          }else{
            data.checked = false
          }
          return data
        })

        dispatch({
          type: 'GET_LOCATIONS_CHECKED',
          data
        })
      }
    })
  }
}

export function getNotifications(data){
  const auth = new parseStorage()
  return dispatch => {
    dispatch({
      type: 'GET_NOTIFICATIONS',
      payload: 
        axios.get(API_URL + `/notifications`, {
          headers: {
              'Authorization' : 'Bearer ' + auth.token,
              'Accept' : 'application/json',                
          }})                
    })
  }
}